<template>
  <div class="card-form">
    <el-row :gutter="10">
      <el-col :span="10">
        <page-location-table @addTop="addTop" />
      </el-col>
      <el-col :span="14">
        <location-right ref="rightTable" />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import PageLocationTable from './components/location-table/index.vue'
import LocationRight from './components/location-right/index.vue'
export default {
  name: 'master-location',
  components: {
    PageLocationTable,
    LocationRight,
  },
  methods: {
    addTop() {
      this.$refs.rightTable.addTop()
    },
  },
}
</script>
